import * as React from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import zIndex from 'styles/tools/z-index'
import { mediaQueryUp } from 'components/utils/breakpoint'

const MobileStickyHeader = styled.div`
  position: sticky;
  top: 0;
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
  box-shadow: ${props => props.theme.shadow.bottom.small};
  z-index: ${zIndex.stickyFooter};

  padding: ${rem(8)} ${rem(16)};

  ${mediaQueryUp.tablet} {
    display: none;
  }
`

interface Props {
  children?: React.ReactNode
}

function AccommodationOfferPageStickyHeaderMobile({ children }: Props) {
  return (
    <MobileStickyHeader>
      {children}
    </MobileStickyHeader>
  )
}

export default AccommodationOfferPageStickyHeaderMobile
